import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearDepotFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'depot')

  layer.getSource()?.clear()
}
